export const APP_TITLE = 'Stamp Free';
